import { render } from "./App.vue?vue&type=template&id=021a94b3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=021a94b3&lang=css"

import exportComponent from "/home/runner/work/dashboard.lims.ninja/dashboard.lims.ninja/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__